import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllBanks = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.BankAPI}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getBankById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.BankAPI}?isAll=false&&CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

const insertBank = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.BankAPI, input);
  return data;
};

const updateBank = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.BankAPI, input);
  return data;
};

const deleteBank = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.BankAPI}?CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

export const useGetBanksQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetBanks],
    queryFn: () => getAllBanks(input),
  });
};

export const useGetBankByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.BankAPI],
    queryFn: () => getBankById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertBankMutation = () => {
  return useMutation({
    mutationFn: insertBank,
  });
};

export const useUpdateBankMutation = () => {
  return useMutation({
    mutationFn: updateBank,
  });
};

export const useDeleteBankMutation = () => {
  return useMutation({
    mutationFn: deleteBank,
  });
};
